<script lang="ts">
  import { agentName, appTheme } from '../lib/stores';
  import { request } from '../lib/api';

  let { onLogout }: { onLogout: () => void } = $props();

  import UpgradeModal from '../lib/UpgradeModal.svelte';

  let paywallMessage = $state('');
  let loading = $state(true);
  let showUpgrade = $state(false);

  // The fetch below swallows its error, so this screen has to read correctly
  // with no message at all: before this existed a failed call left the card
  // unrendered and the page was two buttons with no reason on it.
  //
  // Deliberately account-type-neutral. App.svelte returns at `!$userActive`
  // BEFORE it reads /onboarding/status, so `setVocabulary` never runs for a
  // paywalled user — the browser cannot know whether this is a Sales or a Fund
  // org. The server-rendered message does know; this fallback must not guess.
  const FALLBACK = 'Your Dealton trial has ended, so I\'ve paused my work on your account.'
    + '\n\nEverything we built together is still here. When you continue, I pick up from'
    + ' the same records rather than starting over.'
    + '\n\nChoose a plan below to carry on, or reply to any of my emails and the Dealton'
    + ' team will follow up.';
  const paragraphs = $derived(
    (paywallMessage.trim() || FALLBACK).split('\n\n').map(p => p.trim()).filter(Boolean));

  import { onMount } from 'svelte';
  onMount(async () => {
    try {
      const resp = await request<{ content: string }>('/george-messages/paywall');
      paywallMessage = resp.content;
    } catch {}
    loading = false;
  });
</script>

<div class="paywall-container">
  <!-- George's personal message -->
  {#if loading}
    <div class="paywall-loading">
      <img class="george-avatar" src={$appTheme === 'dark' ? '/mark-dark.svg' : '/mark.svg'} alt="Dealton" />
      <p class="text-dim">{$agentName || 'Dealton'} is writing you a message...</p>
    </div>
  {:else}
    <div class="paywall-george-card">
      <div class="paywall-george-identity">
        <img class="george-avatar" src={$appTheme === 'dark' ? '/mark-dark.svg' : '/mark.svg'} alt="Dealton" />
        <span class="george-name">{$agentName || 'Dealton'}</span>
      </div>
      <div class="paywall-george-body">
        {#each paragraphs as para}
          <p>{para}</p>
        {/each}
      </div>
    </div>
  {/if}

  <div class="paywall-actions">
    <button class="paywall-cta" onclick={() => showUpgrade = true}>
      Continue Working Together
    </button>
    <button class="paywall-logout" onclick={onLogout}>Log out</button>
  </div>
</div>

<UpgradeModal show={showUpgrade} onClose={() => showUpgrade = false} />

<style>
  .paywall-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 80vh;
    padding: 40px 20px;
    gap: 32px;
  }
  .paywall-loading {
    text-align: center;
  }
  .paywall-loading .george-avatar { width: 36px; height: 36px; display: block; margin-bottom: 12px; object-fit: contain; }

  .paywall-george-card {
    max-width: 560px;
    width: 100%;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: var(--bg-surface);
    overflow: hidden;
  }
  .paywall-george-identity {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border-bottom: 1px solid var(--border);
    background: rgba(59, 130, 246, 0.04);
  }
  .george-avatar { width: 24px; height: 24px; object-fit: contain; }
  .george-name { font-weight: 600; font-size: 14px; color: var(--text); }
  .paywall-george-body {
    padding: 20px;
  }
  .paywall-george-body p {
    font-size: 14px;
    line-height: 1.7;
    color: var(--text);
    margin: 0 0 12px 0;
  }
  .paywall-george-body p:last-child { margin-bottom: 0; }

  .paywall-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  .paywall-cta {
    padding: 12px 36px;
    background: var(--accent);
    color: #fff;
    border: none;
    border-radius: var(--radius);
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
  }
  .paywall-cta:hover { opacity: 0.9; }
  .paywall-logout {
    background: none;
    border: none;
    color: var(--text-muted);
    font-size: 13px;
    cursor: pointer;
    text-decoration: underline;
  }
</style>
